import React from 'react'
import expandLogo from '../../../assets/images/Expand Arrow copy.png';

const TransferTypeSB = (props) => {

    let { transferType, setTransferType, selectTransferType, transferTypeData, setExpandTransferType, expandTransferType, shadow } = props;

    const handleClick = (item) => {
        setTransferType(item);
        setExpandTransferType(false);
    }

    return (
            <div className='flex z-10 relative w-full'>
                <div className={`px-2 py-2 w-full flex items-center justify-between rounded-sm cursor-pointer ${shadow ? 'shadow-md bg-bgColor text-fgColor'  : 'bg-transparent text-black border-2 border-gray-500'}`}
                    onClick={(e) => selectTransferType(e)}>
                    <div>{ transferType.transactionType ? transferType.transactionType : " "}</div>
                    <img src={expandLogo} alt="Expand-logo" className='w-6' />
                </div>
                {
                    expandTransferType ?
                        <div className="bg-bgColor text-fgColor w-full absolute top-[50px] cursor-pointer overflow-auto h-[210px] shadow-md">
                            {
                                transferTypeData && transferTypeData.map((item, index) => (
                                    <div key={index}
                                        className={`${item.transactionTypeId !== item.length ? "border-b" : "border-b-0"}  py-3
                                        px-4 hover:bg-primary hover:text-rectangle  transition-all duration-100 `}
                                        onClick={()=>handleClick(item)}
                                    >
                                        {item.transactionType}
                                    </div>
                                ))
                            }
                        </div> : ""
                }
                
            </div>
        )
}

export default TransferTypeSB